// @ts-nocheck
import { fleetPartnersInitialApi as api } from './initialApi';
export const addTagTypes = [
  'vehicle-enrollment-controller',
  'org-enrollment-controller',
  'gmf-controller',
  'fleetio-controller',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      enrollOrUnenrollVehicles: build.mutation<
        EnrollOrUnenrollVehiclesApiResponse,
        EnrollOrUnenrollVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/vehicle-enrollments/${queryArg.providerCode}`,
          method: 'POST',
          body: queryArg.enrollVehiclesRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      createOrgEnrollment: build.mutation<
        CreateOrgEnrollmentApiResponse,
        CreateOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/org-enrollments`,
          method: 'POST',
          body: queryArg.createOrgEnrollmentRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      validateCredentials: build.mutation<
        ValidateCredentialsApiResponse,
        ValidateCredentialsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/org-enrollments/validate-credentials`,
          method: 'POST',
          body: queryArg.validateCredentialsRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      getVehicleDetails: build.mutation<
        GetVehicleDetailsApiResponse,
        GetVehicleDetailsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/gmf/vehicles/details`,
          method: 'POST',
          body: queryArg.gmfVehicleDetailsRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      lookupAuthorizedUser: build.query<
        LookupAuthorizedUserApiResponse,
        LookupAuthorizedUserApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/gmf/organizations/users/lookup`,
          method: 'POST',
          body: queryArg.gmfAuthorizedUserLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['gmf-controller'],
      }),
      lookupServices: build.mutation<
        LookupServicesApiResponse,
        LookupServicesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/gmf/organizations/services/lookup`,
          method: 'POST',
          body: queryArg.gmfServiceLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      lookupOrganization: build.query<
        LookupOrganizationApiResponse,
        LookupOrganizationApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/gmf/organizations/lookup`,
          method: 'POST',
          body: queryArg.gmfOrganizationLookupRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['gmf-controller'],
      }),
      validateLineOfCredit: build.mutation<
        ValidateLineOfCreditApiResponse,
        ValidateLineOfCreditApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/gmf/organizations/line-of-credit/validate`,
          method: 'POST',
          body: queryArg.gmfLineOfCreditRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['gmf-controller'],
      }),
      createBulkJob: build.mutation<
        CreateBulkJobApiResponse,
        CreateBulkJobApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/fleetio/bulk-jobs`,
          method: 'POST',
          body: queryArg.fleetioBulkJobRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['fleetio-controller'],
      }),
      getVehiclesEnrollmentView: build.mutation<
        GetVehiclesEnrollmentViewApiResponse,
        GetVehiclesEnrollmentViewApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/enrollment/${queryArg.providerCode}/vehicles-enrollment-view`,
          method: 'POST',
          body: queryArg.vehiclesEnrollmentViewRequestDto,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
        }),
        invalidatesTags: ['vehicle-enrollment-controller'],
      }),
      getVehicleEnrollmentBatch: build.query<
        GetVehicleEnrollmentBatchApiResponse,
        GetVehicleEnrollmentBatchApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/vehicle-enrollments/${queryArg.providerCode}/batches/${queryArg.batchId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['vehicle-enrollment-controller'],
      }),
      listProviders: build.query<ListProvidersApiResponse, ListProvidersApiArg>(
        {
          query: (queryArg) => ({
            url: `/2026-09-22/providers`,
            headers: {
              'cs-organization': queryArg['cs-organization'],
            },
          }),
          providesTags: ['org-enrollment-controller'],
        }
      ),
      providerIntegrationsStatus: build.query<
        ProviderIntegrationsStatusApiResponse,
        ProviderIntegrationsStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/providers/integrations-status`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
          params: {
            providerCode: queryArg.providerCode,
          },
        }),
        providesTags: ['org-enrollment-controller'],
      }),
      getOrgEnrollment: build.query<
        GetOrgEnrollmentApiResponse,
        GetOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/org-enrollments/${queryArg.providerCode}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['org-enrollment-controller'],
      }),
      unlinkOrgEnrollment: build.mutation<
        UnlinkOrgEnrollmentApiResponse,
        UnlinkOrgEnrollmentApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/org-enrollments/${queryArg.providerCode}`,
          method: 'DELETE',
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        invalidatesTags: ['org-enrollment-controller'],
      }),
      getCurrentUser: build.query<
        GetCurrentUserApiResponse,
        GetCurrentUserApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-09-22/fleetio/me`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
      getBulkJob: build.query<GetBulkJobApiResponse, GetBulkJobApiArg>({
        query: (queryArg) => ({
          url: `/2026-09-22/fleetio/bulk-jobs/${queryArg.jobId}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
      getAccounts: build.query<GetAccountsApiResponse, GetAccountsApiArg>({
        query: (queryArg) => ({
          url: `/2026-09-22/fleetio/accounts`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
          },
        }),
        providesTags: ['fleetio-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as fleetPartnersApi };
export type EnrollOrUnenrollVehiclesApiResponse =
  /** status 202 Request was accepted for processing. */ GmResponseCommonEnrollVehiclesResponseDto;
export type EnrollOrUnenrollVehiclesApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  enrollVehiclesRequestDto: EnrollVehiclesRequestDto;
};
export type CreateOrgEnrollmentApiResponse =
  /** status 202 Request was accepted for processing. */ GmResponseCommonOrgEnrollmentResponseDto;
export type CreateOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  createOrgEnrollmentRequestDto: CreateOrgEnrollmentRequestDto;
};
export type ValidateCredentialsApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonValidateCredentialsResponseDto;
export type ValidateCredentialsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  validateCredentialsRequestDto: ValidateCredentialsRequestDto;
};
export type GetVehicleDetailsApiResponse =
  /** status 200 OK */ GmResponseCommonGmfVehicleDetailsResponse;
export type GetVehicleDetailsApiArg = {
  'cs-organization': string;
  gmfVehicleDetailsRequest: GmfVehicleDetailsRequest;
};
export type LookupAuthorizedUserApiResponse =
  /** status 200 OK */ GmResponseCommonGmfAuthorizedUserEligibilityResponse;
export type LookupAuthorizedUserApiArg = {
  'cs-organization': string;
  gmfAuthorizedUserLookupRequest: GmfAuthorizedUserLookupRequest;
};
export type LookupServicesApiResponse =
  /** status 200 OK */ GmResponseCommonGmfServiceLookupResponse;
export type LookupServicesApiArg = {
  'cs-organization': string;
  gmfServiceLookupRequest: GmfServiceLookupRequest;
};
export type LookupOrganizationApiResponse =
  /** status 200 OK */ GmResponseCommonGmfOrganizationLookupResponse;
export type LookupOrganizationApiArg = {
  'cs-organization': string;
  gmfOrganizationLookupRequest: GmfOrganizationLookupRequest;
};
export type ValidateLineOfCreditApiResponse =
  /** status 200 OK */ GmResponseCommonGmfLineOfCreditResponse;
export type ValidateLineOfCreditApiArg = {
  'cs-organization': string;
  gmfLineOfCreditRequest: GmfLineOfCreditRequest;
};
export type CreateBulkJobApiResponse =
  /** status 200 OK */ FleetioBulkJobResponse;
export type CreateBulkJobApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  fleetioBulkJobRequest: FleetioBulkJobRequest;
};
export type GetVehiclesEnrollmentViewApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonVehiclesEnrollmentViewResponseDto;
export type GetVehiclesEnrollmentViewApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Optional fleet scope for fleet manager view. */
  'cs-fleet'?: string;
  /**
                        Continuation token from a previous response (`result.continuation_token`)
                        to fetch the next page.
                     */
  'cs-continuation-token'?: string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  vehiclesEnrollmentViewRequestDto: VehiclesEnrollmentViewRequestDto;
};
export type GetVehicleEnrollmentBatchApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonVehicleEnrollmentBatchResponseDto;
export type GetVehicleEnrollmentBatchApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the integration. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Batch identifier from the enroll or unenroll response. */
  batchId: string;
};
export type ListProvidersApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonProvidersResponseDto;
export type ListProvidersApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type ProviderIntegrationsStatusApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonProviderIntegrationsStatusResponseDto;
export type ProviderIntegrationsStatusApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Optional provider code to filter integration status. */
  providerCode?: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type GetOrgEnrollmentApiResponse =
  /** status 200 Request was successful. */ GmResponseCommonOrgEnrollmentResponseDto;
export type GetOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code for the enrollment. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type UnlinkOrgEnrollmentApiResponse =
  /** status 202 Request was accepted for processing. */ GmResponseCommon;
export type UnlinkOrgEnrollmentApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  /** Provider code to unlink. */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
};
export type GetCurrentUserApiResponse =
  /** status 200 OK */ FleetioUserResponse;
export type GetCurrentUserApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type GetBulkJobApiResponse = /** status 200 OK */ FleetioBulkJobResponse;
export type GetBulkJobApiArg = {
  /** Organization ID. */
  'cs-organization': string;
  jobId: string;
};
export type GetAccountsApiResponse =
  /** status 200 OK */ FleetioAccountResponse[];
export type GetAccountsApiArg = {
  /** Organization ID. */
  'cs-organization': string;
};
export type EnrollVehiclesResponseDto = {
  /** Organization that owns the batch */
  organizationId: string;
  /** Batch identifier for polling enrollment progress */
  batchId: string;
  /** Provider for the batch */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Enroll or unenroll command accepted for this batch */
  action: 'ENROLL' | 'UNENROLL';
  /** Command acceptance status */
  status: 'ACCEPTED';
  /** Number of vehicles requested in this batch */
  requestedCount: number;
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonEnrollVehiclesResponseDto = {
  result?: EnrollVehiclesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EnrollVehiclesRequestDto = {
  /**
                Vehicle identification numbers to enroll or unenroll.
                Entries are trimmed; blank or whitespace-only entries are ignored.
                At least one VIN must remain after normalization.
             */
  vins: string[];
  /** Whether to enroll or unenroll the selected vehicles */
  action: 'ENROLL' | 'UNENROLL';
  /** Client-generated idempotency key for the command */
  idempotencyKey: string;
};
export type ProviderAuthDto = {
  /** Enrollment provider code */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Authentication type for the provider */
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type OrgEnrollmentResponseDto = {
  /** Org enrollment to third party provider identifier */
  id: string;
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** External provider account identifier when known */
  providerAccountId?: string;
  /** Current org enrollment lifecycle status */
  status:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** When the organization enrollment was linked (UTC, ISO-8601). Null until the link is complete. */
  linkedDate?: string;
  /** If enrollment is asynchronous, the integration can be created successfully while vehicle enrollment is tracked by operationId and per-vehicle status */
  operationId?: string;
};
export type GmResponseCommonOrgEnrollmentResponseDto = {
  result?: OrgEnrollmentResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProviderCredentialsDto = {
  /** API key for API_KEY auth providers */
  apiKey?: string;
  /** Username for USERNAME_PASSWORD auth providers */
  username?: string;
  /** Password for USERNAME_PASSWORD auth providers */
  password?: string;
};
export type ConsentRequestDto = {
  /** Terms name accepted by the user */
  termsName: string;
  /** Terms version accepted by the user */
  termsVersion: string;
  /** When the terms were accepted (ISO-8601) */
  acceptedAt: string;
  /** User who accepted the terms */
  acceptedBy?: string;
};
export type CreateOrgEnrollmentRequestDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Provider credentials (write-only; never returned). Optional and ignored when authType is NO_AUTH; required fields depend on authType otherwise. */
  credentials?: ProviderCredentialsDto;
  /** External provider account identifier. Required for GMF and set to the GMF Tax ID. */
  providerAccountId?: string;
  /** Org enrollment lifecycle status. */
  status?:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** Accepted terms and consent metadata. Optional; when an item is provided, termsName, termsVersion, and acceptedAt are required. Service will enforce termsRequired later. */
  consents: ConsentRequestDto[];
  /** Provider-specific JSON object stored with the enrollment. */
  customData?: {
    [key: string]: any;
  };
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type ValidateCredentialsResponseDto = {
  /** Whether the credentials are valid */
  valid: boolean;
  /** Provider identity and auth method that were validated */
  provider: ProviderAuthDto;
};
export type GmResponseCommonValidateCredentialsResponseDto = {
  result?: ValidateCredentialsResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateCredentialsRequestDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Provider credentials (write-only; never returned). Optional and ignored when authType is NO_AUTH; required fields depend on authType otherwise. */
  credentials?: ProviderCredentialsDto;
  authType: 'NO_AUTH' | 'API_KEY' | 'USERNAME_PASSWORD';
};
export type GmfVehicleMetadata = {
  year?: number;
  make?: string;
  model?: string;
  licensePlate?: string;
};
export type GmfVehiclePlan = {
  serviceProvider?: string;
  productDescription?: string;
  serviceEnrollmentDate?: string;
  serviceArchiveDate?: string;
};
export type GmfVehicle = {
  vin?: string;
  vinSource?: string;
  productType?: string;
  status?: string;
  updatedDate?: string;
  terminationDate?: string;
  metadata?: GmfVehicleMetadata;
  plans?: GmfVehiclePlan[];
};
export type GmfVehicleDetailsResponse = {
  vehicles?: GmfVehicle[];
};
export type GmResponseCommonGmfVehicleDetailsResponse = {
  result?: GmfVehicleDetailsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfVehicleDetailsRequest = {
  taxId: string;
  organizationId: string;
};
export type GmfAuthorizedUserEligibilityResponse = {
  authorizedFlag: boolean;
};
export type GmResponseCommonGmfAuthorizedUserEligibilityResponse = {
  result?: GmfAuthorizedUserEligibilityResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfAuthorizedUserLookupRequest = {
  email: string;
  taxId: string;
  organizationId: string;
};
export type GmfServicePlan = {
  fleetId?: string;
  partner?: string;
  activationDate?: string;
  terminationDate?: string;
};
export type GmfServiceLookupResponse = {
  taxId?: string;
  plans?: GmfServicePlan[];
};
export type GmResponseCommonGmfServiceLookupResponse = {
  result?: GmfServiceLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfServiceLookupRequest = {
  taxId: string;
  organizationId: string;
};
export type GmfOrganizationAddress = {
  addressType?: string;
  street?: string;
  city?: string;
  state?: string;
  zipCode?: string;
};
export type GmfOrganizationLookupResponse = {
  taxId?: string;
  businessName?: string;
  address?: GmfOrganizationAddress[];
  dunsId?: string;
  fan?: string;
  website?: string;
  preferredName?: string;
  accountStatus?: string;
};
export type GmResponseCommonGmfOrganizationLookupResponse = {
  result?: GmfOrganizationLookupResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfOrganizationLookupRequest = {
  taxId?: string;
  dunsId?: string;
  organizationId: string;
};
export type GmfLineOfCreditResponse = {
  taxId: string;
  organizationId: string;
  remainingLoc: number;
};
export type GmResponseCommonGmfLineOfCreditResponse = {
  result?: GmfLineOfCreditResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmfLineOfCreditRequest = {
  taxId: string;
  organizationId: string;
};
export type FleetioFailedRecord = {
  /** Position of the record in the request, starting at 0. */
  index: number;
  /** Error messages by field. */
  error_messages?: {
    [key: string]: string[];
  };
};
export type FleetioBulkJobResponse = {
  /** Bulk job ID. */
  id: string;
  /** Job state (e.g. pending, complete). */
  state?: string;
  /** Resource type. */
  resource?: string;
  /** Operation type. */
  operation?: string;
  /** Total records submitted. */
  total_count?: number;
  /** Records created so far. */
  completed_count?: number;
  /** Records that failed processing. */
  failed_count?: number;
  /** Records Fleetio rejected, by position in the request. */
  failed_records?: FleetioFailedRecord[];
};
export type MeterEntryRecord = {
  /** Fleetio vehicle ID. */
  vehicle_id: number;
  /** Date and time of the reading (ISO 8601). */
  date: string;
  /** Meter reading value. */
  value: number;
  /** Set to secondary for a secondary meter reading. Leave empty for the primary meter. */
  meter_type?: 'secondary';
};
export type FleetioBulkJobRequest = {
  /** Meter entry records to upload. */
  records: MeterEntryRecord[];
};
export type VehiclesEnrollmentViewVehicleDto = {
  /** Vehicle identification number */
  vin: string;
  /** Vehicle display name when known */
  name?: string;
  /** License plate when known */
  licensePlate?: string;
  /** Vehicle make when known */
  make?: string;
  /** Vehicle model when known */
  model?: string;
  /** Model year when known */
  year?: string;
  /** Merchandising model when known */
  merchandisingModel?: string;
  /** Propulsion type when known */
  propulsion?: string;
  /** Vehicle image source URI when known */
  vehicleImageSource?: string;
};
export type VehiclesEnrollmentViewItemDto = {
  /** Vehicle */
  vehicle: VehiclesEnrollmentViewVehicleDto;
  /** Current enrollment status */
  enrollmentStatus:
    | 'PENDING_READINESS'
    | 'PENDING_ENROLL'
    | 'ENROLLED'
    | 'PENDING_UNENROLL'
    | 'UNENROLLED'
    | 'ERROR_ENROLLMENT'
    | 'ERROR_UNENROLLMENT';
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Fleet identifier when applicable */
  fleetId?: string;
  /** Fleet display name when applicable */
  fleetName?: string;
  /** Provider-side vehicle identifier when assigned */
  providerVehicleId?: string;
  /** When the vehicle was enrolled */
  enrolledAt?: string;
  /** When the enrollment row was last updated */
  lastUpdatedAt?: string;
  /** Normalized enrollment error when applicable */
  errorType?:
    | 'NO_LICENSE_PLATE'
    | 'DUPLICATE_LICENSE_PLATE'
    | 'PROVIDER_UNAVAILABLE'
    | 'PROVIDER_REQUEST_TIMEOUT'
    | 'UNKNOWN';
};
export type VehiclesEnrollmentViewResponseDto = {
  /** Table rows for the current page */
  items: VehiclesEnrollmentViewItemDto[];
  /** Total rows matching the filter across all pages */
  total_items?: number;
  /**
                Continuation token for the next page via the `cs-continuation-token` request header.
                Null when there is no next page.
             */
  continuation_token?: string;
};
export type GmResponseCommonVehiclesEnrollmentViewResponseDto = {
  result?: VehiclesEnrollmentViewResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehiclesEnrollmentViewSearchDto = {
  /**
                Free-text table search. Searchable columns will be defined when query support is added.
                Not applied in the current stub.
             */
  term?: string;
  /** Sort order for table results; format TBD when query support is added. */
  sort?: string;
};
export type VehiclesEnrollmentViewRequestDto = {
  /** Fleet scope filter when not using cs-fleet header */
  fleetIds: string[];
  /** Filter by enrollment status; omit for all statuses */
  enrollmentStatus?:
    | 'PENDING_READINESS'
    | 'PENDING_ENROLL'
    | 'ENROLLED'
    | 'PENDING_UNENROLL'
    | 'UNENROLLED'
    | 'ERROR_ENROLLMENT'
    | 'ERROR_UNENROLLMENT';
  /**
                VIN list filter. Entries are trimmed; blank or whitespace-only entries are ignored.
                An empty list after normalization means no VIN filter (all vehicles in scope).
             */
  vins: string[];
  /** Table search and sort (separate from fleetIds/vins filters; not yet applied in stub) */
  search: VehiclesEnrollmentViewSearchDto;
  /** Page size */
  size: number;
};
export type VehicleEnrollmentBatchItemDto = {
  /** Vehicle identification number */
  vin: string;
  /** License plate when known */
  licensePlate?: string;
  /** Enrollment state for this vehicle in the batch */
  status:
    | 'PENDING_READINESS'
    | 'PENDING_ENROLL'
    | 'ENROLLED'
    | 'PENDING_UNENROLL'
    | 'UNENROLLED'
    | 'ERROR_ENROLLMENT'
    | 'ERROR_UNENROLLMENT';
  /** Provider-side vehicle identifier when assigned */
  providerVehicleId?: string;
};
export type VehicleEnrollmentBatchResponseDto = {
  /** Organization that owns the batch */
  organizationId: string;
  /** Batch identifier from the enroll or unenroll command */
  batchId: string;
  /** Provider for the batch */
  providerCode: 'COAST' | 'FLEET_IO' | 'GMF';
  /** Enroll or unenroll command for this batch */
  action: 'ENROLL' | 'UNENROLL';
  /** Overall batch processing status */
  status: 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  /** Total vehicles in the batch */
  totalCount: number;
  /** Vehicles that finished processing in the batch */
  completedCount: number;
  /** Vehicles that failed in the batch */
  failedCount: number;
  /** Per-vehicle batch items */
  items: VehicleEnrollmentBatchItemDto[];
};
export type GmResponseCommonVehicleEnrollmentBatchResponseDto = {
  result?: VehicleEnrollmentBatchResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProviderDto = {
  /** Provider identity and auth method */
  provider: ProviderAuthDto;
  /** Whether terms and conditions must be accepted to enroll with this provider */
  termsRequired: boolean;
};
export type ProvidersResponseDto = {
  /** Providers available to the organization */
  providers: ProviderDto[];
};
export type GmResponseCommonProvidersResponseDto = {
  result?: ProvidersResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type VehicleEnrollmentSummaryDto = {
  /** Vehicles currently enrolled */
  enrolled: number;
  /** Vehicles pending enrollment */
  pendingEnrollment: number;
  /** Vehicles pending unenrollment */
  pendingUnEnrollment: number;
  /** Vehicles with enrollment errors */
  errorEnrollment: number;
  /** Vehicles with unenrollment errors */
  errorUnEnrollment: number;
};
export type IntegrationStatusDto = {
  /** Organization that owns the enrollment */
  organizationId: string;
  /** Org enrollment identifier */
  integrationId: string;
  /** Provider-side account identifier associated with the organization enrollment. */
  providerAccountId?: string;
  /** Current org enrollment lifecycle status */
  status:
    | 'PENDING_LINK'
    | 'ACTIVE'
    | 'PENDING_UNLINK'
    | 'ERROR_LINK'
    | 'ERROR_UNLINK'
    | 'DISABLED';
  /** Aggregated vehicle enrollment counts for this integration */
  vehicleEnrollmentStatus: VehicleEnrollmentSummaryDto;
};
export type ProviderWithStatusDto = {
  /** Provider available for organization enrollment */
  provider: ProviderDto;
  /** Organization enrollment status for this provider */
  integrationStatus?: IntegrationStatusDto;
};
export type ProviderIntegrationsStatusResponseDto = {
  /** Providers with their integration status */
  integrations: ProviderWithStatusDto[];
};
export type GmResponseCommonProviderIntegrationsStatusResponseDto = {
  result?: ProviderIntegrationsStatusResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type FleetioUserResponse = {
  /** Fleetio user ID. */
  id: number;
  /** User email address. */
  email?: string;
  /** User first name. */
  first_name?: string;
  /** User last name. */
  last_name?: string;
};
export type FleetioAccountResponse = {
  /** Fleetio account ID. */
  id: number;
  /** Account name. */
  name?: string;
};
export const {
  useEnrollOrUnenrollVehiclesMutation,
  useCreateOrgEnrollmentMutation,
  useValidateCredentialsMutation,
  useGetVehicleDetailsMutation,
  useLookupAuthorizedUserQuery,
  useLookupServicesMutation,
  useLookupOrganizationQuery,
  useValidateLineOfCreditMutation,
  useCreateBulkJobMutation,
  useGetVehiclesEnrollmentViewMutation,
  useGetVehicleEnrollmentBatchQuery,
  useListProvidersQuery,
  useProviderIntegrationsStatusQuery,
  useGetOrgEnrollmentQuery,
  useUnlinkOrgEnrollmentMutation,
  useGetCurrentUserQuery,
  useGetBulkJobQuery,
  useGetAccountsQuery,
} = injectedRtkApi;
